import { render, staticRenderFns } from "./CompraRatel.vue?vue&type=template&id=8fd0c3a8&"
import script from "./CompraRatel.vue?vue&type=script&lang=js&"
export * from "./CompraRatel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports